var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 37,
    height: 37,
    rx: 18.5,
    stroke: "#7F56D9",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 15.8333H15C14.558 15.8333 14.1341 16.0088 13.8215 16.3214C13.509 16.634 13.3334 17.0579 13.3334 17.4999V24.9999C13.3334 25.4419 13.509 25.8659 13.8215 26.1784C14.1341 26.491 14.558 26.6666 15 26.6666H22.5C22.9421 26.6666 23.366 26.491 23.6786 26.1784C23.9911 25.8659 24.1667 25.4419 24.1667 24.9999V24.1666",
    stroke: "#828282",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 14.1666L25.8333 16.6666M26.9875 15.4875C27.3157 15.1593 27.5001 14.7141 27.5001 14.25C27.5001 13.7858 27.3157 13.3407 26.9875 13.0125C26.6593 12.6843 26.2142 12.4999 25.75 12.4999C25.2858 12.4999 24.8407 12.6843 24.5125 13.0125L17.5 20V22.5H20L26.9875 15.4875Z",
    stroke: "#828282",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditImage);
export default __webpack_public_path__ + "static/media/edit-image.145f6d9e5fa6e36212558c76bf0779fe.svg";
export { ForwardRef as ReactComponent };